import { render, staticRenderFns } from "./GraphBestSellingProductGroup.vue?vue&type=template&id=6b9f90e7&lang=pug&"
import script from "./GraphBestSellingProductGroup.vue?vue&type=script&lang=js&"
export * from "./GraphBestSellingProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./GraphBestSellingProductGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports